
import * as TransactionsActions from '../actions/transactions.actions';
import { initialTransactionTypesState, ITransactionTypesState } from '../../state/transaction-type.state';
import { transactionTypeAdapter } from '../selectors/transaction-types.selector';

export function TransactionTypesReducer(
state = initialTransactionTypesState, action: TransactionsActions.TransactionsTypesActions): ITransactionTypesState {

    switch (action.type) {
        case TransactionsActions.TransactionsActionTypes.SELECT_CASH_TRANSACTION_TYPE:
            return {
                ...state,
                selectedCashType: action.payload
            };

        case TransactionsActions.TransactionsActionTypes.SELECT_REVENUE_TRANSACTION_TYPE:
            return {
                ...state,
                selectedRevenueType: action.payload
            };

        case TransactionsActions.TransactionsActionTypes.SELECT_SECURITY_TRANSACTION_TYPE:
            return {
                ...state,
                selectedSecurityType: action.payload
            };

        case TransactionsActions.TransactionsActionTypes.SET_ACCOUNT_TYPE:
            return {
                ...state,
                selectedAccountType: action.payload
            };

        default:
            return state;
    }
}

